/**
 * 官方图片：按 profile 分发（各 profile 可共用或独立 Base URL / Key）
 */
import { submitVolcSeedream4Image } from './volc-seedream-4'
import { submitVolcSeedream5Image } from './volc-seedream-5'
import { submitVolcGptImage15 } from './volc-gpt-image-1-5'
import { submitBflFluxPro11UltraImage } from './bfl-flux-pro-1-1-ultra'
import { submitBflFlux2Image } from './bfl-flux-2'
import { submitDashScopeQwenImage20ProImage } from './dashscope-qwen-image-2-0-pro'
import { submitDashScopeZImageTurboImage } from './dashscope-z-image-turbo'
import { submitGoogleNanoBanana2Image } from './google-nano-banana-2'
import { submitNanoBananaV25Image, submitNanoBananaV31Image } from './google-nano-banana-31'

export function submitOfficialImage(profileId, params) {
  if (profileId === 'volc-seedream-4') {
    return submitVolcSeedream4Image(params)
  }
  if (profileId === 'volc-seedream-5') {
    return submitVolcSeedream5Image(params)
  }
  if (profileId === 'volc-gpt-image-1-5') {
    return submitVolcGptImage15(params)
  }
  if (profileId === 'bfl-flux-pro-1-1-ultra') {
    return submitBflFluxPro11UltraImage(params)
  }
  if (profileId === 'bfl-flux-2') {
    return submitBflFlux2Image(params)
  }
  if (profileId === 'dashscope-qwen-image-2-0-pro') {
    return submitDashScopeQwenImage20ProImage(params)
  }
  if (profileId === 'dashscope-z-image-turbo') {
    return submitDashScopeZImageTurboImage(params)
  }
  if (profileId === 'google-nano-banana-2') {
    // 后端中转模式：根据 genType 选择 v2.5 或 v3.1 接口
    var genType = params && params.genType
    if (genType === 'v25') {
      return submitNanoBananaV25Image(params)
    }
    if (genType === 'v31') {
      return submitNanoBananaV31Image(params)
    }
    // 兼容：无 genType 时走 v3.1 默认
    return submitNanoBananaV31Image(params)
  }
  if (profileId === 'nano-banana-v25') {
    return submitNanoBananaV25Image(params)
  }
  if (profileId === 'nano-banana-v31') {
    return submitNanoBananaV31Image(params)
  }
  return Promise.reject(new Error('Unknown official image profile: ' + profileId))
}
